<template>
  <div>
    <p style="text-align:right;padding:8px;margin:0;color:orange;">
      <v-icon color="orange" small style="padding: 0 4px;">pan_tool</v-icon>完成相关操作之后点击<b>确认导入</b>才能完成最终导入
      <v-btn color="primary" width="100" round v-if="loading" disabled>正在导入</v-btn>
      <template v-else>
        <v-btn color="primary" round @click="doImport">确认导入</v-btn>
        <v-btn round @click="cancelImport">取消导入</v-btn>
      </template>
    </p>
    <v-tabs v-model="tabIndex" v-if="inited" centered>
      <v-tab>导入题目</v-tab>
      <v-tab v-if="oldQues.length > 0">试卷中其它题目</v-tab>
      <v-tab-item>
        <v-container fluid class="px-0 py-0">
          <v-alert :value="true" color="warning" outline>
            <template v-if="repeatCount > 0">
              系统已用红色标出{{ repeatCount }}个重复题目，通过点击题目后的<b>详情</b>可查看并进行替换等操作。
              <v-radio-group row hide-details v-model="radios" style="padding: 8px;" v-if="repeatCount > 0">
                <v-radio label="覆盖重复原题" value="overide"></v-radio>
                <v-radio label="忽略重复题目" value="ignore"></v-radio>
                <v-radio label="保留重复原题" value="replace"></v-radio>
                <v-radio label="手工逐个确认" value="custom"></v-radio>
              </v-radio-group>
              <p v-if="radios == 'overide'">直接用导入的题目覆盖原题</p>
              <p v-else-if="radios == 'ignore'">不管重复不重复，直接创建新的题目</p>
              <p v-else-if="radios == 'replace'">不导入重复的题目，保留原题</p>
              <p v-else-if="radios == 'custom'">自行逐题确认如何处理重复</p>
            </template>
            <template v-else>
              请确认导入的题目，然后点击右上角<b>确认导入</b>完成最终导入。
            </template>
          </v-alert>

          <v-divider />
          <v-layout row wrap>
            <v-flex :xs7="cQues" :xs12="!cQues">
              <v-expansion-panel v-model="expansionIndex">
                <v-expansion-panel-content v-for="(g, idx) in cfg.message" :key="g.id">
                  <template v-slot:header>
                    <div class="group-title">
                      {{ seqs[idx] }}、 {{ g.title }}(共<span>{{
                          g.items.length
                      }}</span>题)
                    </div>
                  </template>
                  <v-data-table style="height: 550px; overflow-y: auto;" :items="g.items" hide-actions hide-headers>
                    <template v-slot:items="props">
                      <tr>
                        <td style="width: 10px">{{ props.index + 1 }}</td>
                        <td :class="{
                          'ques-repeat-c':
                            props.item.question.repeatHash.cqs.length > 0,
                          'ques-repeat-t':
                            props.item.question.repeatHash.hqs.length > 0,
                        }">
                          {{ props.item.question.title }}
                        </td>
                        <td nowrap class="acts">
                          <v-chip small color="red" text-color="white" v-if="props.item.question.deleted"
                            @input="toggleDelQues(idx, props.index)" close>已标记删除</v-chip>
                          <template v-else>
                            <v-chip small color="red" text-color="white" v-if="props.item.question.overide"
                              @input="cancelFlagQues(1, idx, props.index)" close>已标记覆盖</v-chip>
                            <v-chip small color="red" text-color="white" v-else-if="props.item.question.replace"
                              @input="cancelFlagQues(2, idx, props.index)" close>已标记替换</v-chip>
                            <span @click="toggleDelQues(idx, props.index)">删除</span>
                          </template>
                          <span @click="onDetail(props.item.question)">详情</span>
                          <v-icon v-if="cQues && cQues.id == props.item.question.id" :size="20">arrow_forward</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex v-if="cQues" xs5 class="right">
              <div v-if="cQues" class="ques">
                <h5>导入题目</h5>
                <div>
                  <p class="ques-title">
                    <span>[{{
                        cQues.type == 1
                          ? "单选题"
                          : cQues.type == 2
                            ? "判断题"
                            : cQues.type == 3
                              ? "多选题"
                              : "复合题"
                    }}]</span>{{ cQues.title }}
                  </p>
                  <template v-if="cQues.attachs">
                    <div class="ques-image" v-for="img in cQues.attachs" :key="img">
                      <img :src="img" />
                    </div>
                  </template>
                  <!-- 根据题目类型现实答案选项 -->
                  <ul>
                    <template v-for="i in 6">
                      <li :key="i" v-if="cQues['opt' + i]">
                        {{ cQues["opt" + i] }}
                      </li>
                    </template>
                  </ul>
                </div>
                <v-divider />

                <div v-if="cQues.repeatHash.hqs.length > 0">
                  <h5>可能重复的题</h5>
                  <div class="ques-view" v-for="qs in cQues.repeatHash.hqs" :key="qs.id">
                    <v-chip small color="red" text-color="white" v-if="cQues.innerRepeats && cQues.innerRepeats[qs.id]"
                      class="repeat-type">试卷内</v-chip>
                    <span>编号：{{ qs.id }}</span>
                    <div class="acts">
                      <template v-if="
                        !cQues.deleted && !cQues.overide && !cQues.replace
                      ">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on" @click="flagQues(1, qs.id)">覆盖</span>
                          </template>
                          <span>用导入的题目覆盖此题目</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on" @click="flagQues(2, qs.id)">替换</span>
                          </template>
                          <span>用此题替换导入的题目</span>
                        </v-tooltip>
                      </template>
                      <template v-else>
                        <span v-if="cQues.overide == qs.id">已标记覆盖</span><span
                          v-else-if="cQues.replace == qs.id">已标记替换</span>
                      </template>
                    </div>
                    <question-view :cfg="{ targetId: qs.id }" />
                  </div>
                </div>

                <div v-if="cQues.repeatHash.cqs.length > 0">
                  <h5>编码重复的题</h5>
                  <div class="ques-view" v-for="qs in cQues.repeatHash.cqs" :key="qs.id">
                    <v-chip small color="red" text-color="white" v-if="cQues.innerRepeats && cQues.innerRepeats[qs.id]"
                      class="repeat-type">试卷内</v-chip>
                    <span>编号：{{ qs.id }}</span>
                    <div class="acts">
                      <template v-if="
                        !cQues.deleted && !cQues.overide && !cQues.replace
                      ">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on" @click="flagQues(1, qs.id)">覆盖</span>
                          </template>
                          <span>用导入的题目覆盖此题目</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on" @click="flagQues(2, qs.id)">替换</span>
                          </template>
                          <span>用此题替换导入的题目</span>
                        </v-tooltip>
                      </template>
                      <template v-else>
                        <span v-if="cQues.overide == qs.id">已标记覆盖</span><span
                          v-else-if="cQues.replace == qs.id">已标记替换</span>
                      </template>
                    </div>
                    <question-view :cfg="{ targetId: qs.id }" />
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item v-if="oldQues.length > 0">
        <v-alert :value="true" color="warning" outline>
          以下是原试卷中的其它题目（不包括与导入中重复的），请您自行决定是否删除。点击<b>确认导入</b>之后本次删除操作才有效。
          <v-btn v-if="selectDelAllOldQues" style="float: right" color="primary" outline round
            @click="cancelDelAllOldQues">取消删除</v-btn>
          <v-btn v-else style="float: right" color="primary" outline round @click="delAllOldQues">全部删除</v-btn>
        </v-alert>
        <v-data-table :items="oldQues" hide-actions hide-headers>
          <template v-slot:items="props">
            <td>{{ props.item.questionTitle }}</td>
            <td>
              {{
                  props.item.question.type == 1
                    ? "单选题"
                    : props.item.question.type == 2
                      ? "判断题"
                      : props.item.question.type == 3
                        ? "多选题"
                        : "复合题"
              }}
            </td>
            <td class="acts">
              <v-chip small color="red" text-color="white" v-if="props.item.deleted"
                @input="cancelDelOldQues(props.index)" close>已标记删除</v-chip><span v-else
                @click="delOldQues(props.index)">删除</span>
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
const QuestionView = () => import("./question-view.vue");
export default {
  name: "paper-import-parse",
  props: { cfg: Object },
  watch: {
    cfg() {
      this.init();
    },
  },
  components: {
    "question-view": QuestionView,
  },
  data() {
    return {
      seqs: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],
      tabIndex: 0,
      cQues: null,
      baseUrl: this.$const.baseUrl,
      expansionIndex: 0,
      oldQues: [],
      radios: 'overide',
      inited: false,
      loading: false,
      repeatCount: 0
    };
  },
  computed: {
    selectDelAllOldQues() {
      let oldQues = this.oldQues, del = 0;
      for (let q of oldQues) {
        if (q.deleted) { del++; }
      }
      return del == oldQues.length;
    }
  },
  methods: {
    init() {
      /*如果有原题目题目 */
      if (!this.cfg || this.inited) {
        return;
      }
      let hash = this.cfg.hash || {}, /*重复题目hash */
        oldGroups = this.cfg.groups || [],/*试卷已存在的题目 */
        groups = this.cfg.message;/*导入的题目 */

      let titleHash = {},
        gIdx = 0, repeatCount = 0;
      for (let g of groups) {
        let j = 0;
        for (let i of g.items) {
          let q = i.question,
            repeat = hash[i.question.id];
          if (q.attachs) {
            let attachs = q.attachs.split(',');
            q.attachs = [];
            for (let a of attachs) {
              q.attachs.push(`${this.$const.baseUrl}/home/admin/c/paper/image/tmp/${a.split('/')[0]}`);
            }
          }
          titleHash[q.titleHash] = q;
          q.repeatHash = {
            cqs: repeat && repeat.cqs ? repeat.cqs : [],
            hqs: repeat && repeat.hqs ? repeat.hqs : [],
          };
          if (q.repeatHash.cqs.length > 0 || q.repeatHash.hqs.length > 0) {
            repeatCount++;
          }
          q.gIndex = gIdx;
          q.index = j++;
        }
        gIdx++;
      }

      let oldQues = [];
      for (let g of oldGroups) {
        for (let i of g.items) {
          let q = i.question,
            hq = titleHash[q.titleHash];
          if (hq) {//如果在导入中已经有（titleHash）就不加入到没有中去
            hq.innerRepeats = hq.innerRepeats || {};
            hq.innerRepeats[q.id] = q;
          } else {
            i.deleted = false;
            oldQues.push(i);
          }
        }
      }

      this.oldQues = oldQues;
      this.repeatCount = repeatCount;
      this.inited = true;
    },
    cancelImport() {
      let self = this;
      self.$axios.get('/home/admin/c/paper/cancel_import').then(() => {
        self.$dialog.close();
      });
    },
    doImport() {
      let self = this,
        oldDels = [],
        overides = [],
        replaces = [],
        dels = [];
      self.loading = true;
      for (let q of self.oldQues) {
        if (q.deleted) {
          oldDels.push(q.questionId);//需要删除的题目
        }
      }
      for (let g of self.cfg.message) {
        for (let qi of g.items) {
          let q = qi.question;
          if (q.deleted) {//导入删除的题目
            dels.push(q.id);
          } else if (q.overide) {//需要覆盖的
            overides.push(q.id + "_" + q.overide);
          } else if (q.replace) {//需要替换的
            replaces.push(q.id + "_" + q.replace);
          }
        }
      }
      self.$axios
        .post(
          `/home/admin/c/paper/do_import/${self.cfg.paperId}`,
          self.$qs.stringify({
            replaces: replaces.join("-"),
            overides: overides.join("-"),
            dels: dels.join("-"),
            old_dels: oldDels.join("-"),
            opt: self.radios,
          })
        )
        .then((r) => {
          self.loading = false;
          if (r.data.status == "ok") {
            self.$dialog.close();
            self.$status("导入成功～", "success");
            if (self.cfg.onSuccess) {
              self.cfg.onSuccess();
            }
          } else {
            self.$status(r.data.message || "导入失败～", "error");
          }
        });
    },
    onDetail(q) {
      this.cQues = q;
    },
    flagQues(t, qid) {
      if (t == 1) {
        this.cQues.overide = this.cQues.overide == qid ? null : qid;
      } else {
        this.cQues.replace = this.cQues.replace == qid ? null : qid;
      }
      let group = this.cfg.message[this.cQues.gIndex];
      this.$set(this.cfg.message, this.cQues.gIndex, group);
    },
    cancelFlagQues(t, gIdx, idx) {
      let g = this.cfg.message[gIdx],
        q = g.items[idx].question;
      if (t == 1) {
        q.overide = null;
      } else {
        q.replace = null;
      }
      if (this.cQues.id == q.id) {
        this.cQues = q;
      }
      this.$set(this.cfg.message, gIdx, g);
    },
    toggleDelQues(gIdx, idx) {
      let g = this.cfg.message[gIdx],
        q = g.items[idx].question;
      q.deleted = !q.deleted;
      this.$set(this.cfg.message, gIdx, g);
    },
    delOldQues(idx) {
      let q = this.oldQues[idx];
      q.deleted = true;
      this.$set(this.oldQues, idx, q);
    },
    cancelDelOldQues(idx) {
      let q = this.oldQues[idx];
      q.deleted = false;
      this.$set(this.oldQues, idx, q);
    },
    delAllOldQues() {
      for (let idx in this.oldQues) {
        let q = this.oldQues[idx];
        q.deleted = true;
        this.$set(this.oldQues, idx, q);
      }
    },
    cancelDelAllOldQues() {
      for (let idx in this.oldQues) {
        let q = this.oldQues[idx];
        q.deleted = false;
        this.$set(this.oldQues, idx, q);
      }
    }
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.group-title {
  font-size: 16px;
}

.group-title span {
  color: red;
  padding: 4px;
}

.ques-repeat-c {
  color: orange;
}

.ques-repeat-t {
  color: red;
}

.ques-tip {
  padding-right: 4px;
}

.ques-tip b {
  color: red;
}

.acts span {
  cursor: pointer;
  color: #0068b7;
  margin: 0 4px;
}

.right {
  border-left: 1px solid #eee;
  padding: 8px;
}

.ques .ques-title span {
  margin-right: 4px;
  color: #0068b7;
}

.ques .ques-image {
  max-width: 100%;
}

h5 {
  color: red;
  margin: 8px 0;
}

.ques-view {
  border: 1px solid #eee;
  border-radius: 4px;
  margin: 4px 0;
  padding: 8px;
}

.ques-view .acts,
.ques .acts {
  float: right;
}

.v-input--selection-controls {
  margin-top: 8px !important;
}
</style>
